export const REGISTER_FIELD_CHANGE = 'ACCOUNTS/REGISTER_FIELD_CHANGE';
export const SET_ACCOUNTS = 'ACCOUNTS/SET_ACCOUNTS';
export const HANDLE_REGISTRATION = 'ACCOUNTS/HANDLE_REGISTRATION';
export const HANDLE_UPDATE = 'ACCOUNTS/HANDLE_UPDATE';
export const HANDLE_LOADING = 'ACCOUNTS/HANDLE_LOADING';
export const CLEAR_REGISTRATION = 'ACCOUNTS/CLEAR_REGISTRATION';
